import type { FC } from 'react'
import { Button } from '#components/Button'

export const ClearCaches: FC = () => {
  return (
    <Button
      size="xs"
      onClick={() => {
        window.addEventListener('beforeunload', async () => {
          localStorage.clear()
          const dbs = await indexedDB.databases()
          for (const db of dbs) {
            if (db.name) {
              console.log('Dropping DB', db.name)
              indexedDB.deleteDatabase(db.name)
            }
          }
        })
        window.location.reload()
      }}
    >
      Clear caches & reload
    </Button>
  )
}
